{
  "fieldia": "0.13",
  "id": "backlog",
  "data": { "kind": "record", "model": "work.item" },
  "records": { "one": "work item", "other": "work items", "a": "a work item" },
  "look": { "theme": "fluent", "density": "compact" },
  "maxWidth": "full",
  "fields": {
    "order": { "type": "integer", "label": "Order" },
    "number": { "type": "integer", "label": "ID" },
    "work_type": {
      "type": "selection",
      "label": "Work Item Type",
      "options": [
        { "value": "bug", "label": "Bug" },
        { "value": "task", "label": "Task" },
        { "value": "story", "label": "User Story" }
      ]
    },
    "title": { "type": "char", "label": "Title" },
    "state": {
      "type": "selection",
      "label": "State",
      "options": [
        { "value": "new", "label": "New" },
        { "value": "active", "label": "Active" },
        { "value": "resolved", "label": "Resolved" },
        { "value": "closed", "label": "Closed" }
      ]
    },
    "story_points": { "type": "float", "label": "Story Points" },
    "value_area": {
      "type": "selection",
      "label": "Value Area",
      "options": [
        { "value": "business", "label": "Business" },
        { "value": "architectural", "label": "Architectural" }
      ]
    },
    "area": { "type": "many2one", "label": "Area", "relation": "work.area" },
    "iteration": { "type": "many2one", "label": "Iteration Path", "relation": "work.iteration" },
    "tags": { "type": "many2many", "label": "Tags", "relation": "work.tag" },
    "parent_id": { "type": "many2one", "label": "Parent", "relation": "work.item" }
  },
  "layout": {
    "type": "list",
    "id": "backlog-list",
    "columns": ["order", "work_type", "title", "state", "story_points", "value_area", "iteration", "tags"],
    "sort": [{ "field": "order" }],
    "pageSize": 100,
    "searchFields": ["title", "number", "tags"],
    "cells": {
      "order": { "align": "start", "width": "59px", "rule": false },
      "work_type": { "width": "36px" },
      "title": {
        "width": "911px",
        "rule": "42px",
        "lead": {
          "field": "work_type",
          "looks": {
            "bug": { "icon": "bug", "colour": "#cc293d" },
            "task": { "icon": "task", "colour": "#f2cb1d" },
            "story": { "icon": "story", "colour": "#009ccc" }
          }
        }
      },
      "state": {
        "widget": "dot",
        "width": "68px",
        "options": { "colours": { "new": "#b2b2b2", "active": "#007acc", "resolved": "#ff9d00", "closed": "#339933" } }
      },
      "story_points": { "width": "61px" },
      "value_area": { "width": "100px" },
      "iteration": { "width": "200px" },
      "tags": { "width": "200px" }
    },
    "choose": false,
    "sortable": false,
    "search": "fields",
    "filterFields": ["work_type", "state", "area", "iteration", "tags"],
    "filterLabels": { "iteration": "Iteration" },
    "parentField": "parent_id"
  },
  "translations": {
    "ar": {
      "Order": "الترتيب",
      "ID": "المعرّف",
      "Work Item Type": "نوع بند العمل",
      "Bug": "خلل",
      "Task": "مهمة",
      "User Story": "قصة مستخدم",
      "Title": "العنوان",
      "State": "الحالة",
      "New": "جديد",
      "Active": "نشط",
      "Resolved": "محلول",
      "Closed": "مغلق",
      "Story Points": "نقاط القصة",
      "Value Area": "مجال القيمة",
      "Business": "الأعمال",
      "Architectural": "معماري",
      "Area": "المجال",
      "Iteration Path": "مسار التكرار",
      "Iteration": "التكرار",
      "Tags": "الوسوم",
      "Parent": "الأصل"
    },
    "de": {
      "Order": "Reihenfolge",
      "ID": "ID",
      "Work Item Type": "Arbeitselementtyp",
      "Bug": "Fehler",
      "Task": "Aufgabe",
      "User Story": "User Story",
      "Title": "Titel",
      "State": "Status",
      "New": "Neu",
      "Active": "Aktiv",
      "Resolved": "Gelöst",
      "Closed": "Geschlossen",
      "Story Points": "Story Points",
      "Value Area": "Wertbereich",
      "Business": "Geschäft",
      "Architectural": "Architektur",
      "Area": "Bereich",
      "Iteration Path": "Iterationspfad",
      "Iteration": "Iteration",
      "Tags": "Tags",
      "Parent": "Übergeordnet"
    },
    "fr": {
      "Order": "Ordre",
      "ID": "ID",
      "Work Item Type": "Type d’élément de travail",
      "Bug": "Bogue",
      "Task": "Tâche",
      "User Story": "Récit utilisateur",
      "Title": "Titre",
      "State": "État",
      "New": "Nouveau",
      "Active": "Actif",
      "Resolved": "Résolu",
      "Closed": "Fermé",
      "Story Points": "Points de récit",
      "Value Area": "Domaine de valeur",
      "Business": "Métier",
      "Architectural": "Architecture",
      "Area": "Zone",
      "Iteration Path": "Chemin d’itération",
      "Iteration": "Itération",
      "Tags": "Balises",
      "Parent": "Parent"
    },
    "tr": {
      "Order": "Sıra",
      "ID": "Kimlik",
      "Work Item Type": "İş öğesi türü",
      "Bug": "Hata",
      "Task": "Görev",
      "User Story": "Kullanıcı hikayesi",
      "Title": "Başlık",
      "State": "Durum",
      "New": "Yeni",
      "Active": "Etkin",
      "Resolved": "Çözümlendi",
      "Closed": "Kapalı",
      "Story Points": "Hikaye puanları",
      "Value Area": "Değer alanı",
      "Business": "İş",
      "Architectural": "Mimari",
      "Area": "Alan",
      "Iteration Path": "Yineleme yolu",
      "Iteration": "Yineleme",
      "Tags": "Etiketler",
      "Parent": "Üst öğe",
      "work item": "iş öğesi",
      "work items": "iş öğeleri",
      "a work item": "bir iş öğesi"
    },
    "fa": {
      "Order": "ترتیب",
      "ID": "شناسه",
      "Work Item Type": "نوع مورد کاری",
      "Bug": "باگ",
      "Task": "وظیفه",
      "User Story": "داستان کاربر",
      "Title": "عنوان",
      "State": "وضعیت",
      "New": "جدید",
      "Active": "فعال",
      "Resolved": "حل‌شده",
      "Closed": "بسته‌شده",
      "Story Points": "امتیاز داستان",
      "Value Area": "حوزهٔ ارزش",
      "Business": "کسب‌وکار",
      "Architectural": "معماری",
      "Area": "ناحیه",
      "Iteration Path": "مسیر تکرار",
      "Iteration": "تکرار",
      "Tags": "تگ‌ها",
      "Parent": "والد",
      "work item": "مورد کاری",
      "work items": "موارد کاری",
      "a work item": "یک مورد کاری"
    },
    "ur": {
      "Order": "ترتیب",
      "ID": "آئی ڈی",
      "Work Item Type": "ورک آئٹم کی قسم",
      "Bug": "بگ",
      "Task": "ٹاسک",
      "User Story": "یوزر اسٹوری",
      "Title": "عنوان",
      "State": "حالت",
      "New": "نیا",
      "Active": "فعال",
      "Resolved": "حل شدہ",
      "Closed": "بند",
      "Story Points": "اسٹوری پوائنٹس",
      "Value Area": "قدر کا شعبہ",
      "Business": "کاروباری",
      "Architectural": "آرکیٹیکچرل",
      "Area": "شعبہ",
      "Iteration Path": "تکرار کا راستہ",
      "Iteration": "تکرار",
      "Tags": "ٹیگز",
      "Parent": "پیرنٹ",
      "work item": "ورک آئٹم",
      "work items": "ورک آئٹمز",
      "a work item": "ایک ورک آئٹم"
    },
    "es": {
      "Order": "Orden",
      "ID": "Id.",
      "Work Item Type": "Tipo de elemento de trabajo",
      "Bug": "Error",
      "Task": "Tarea",
      "User Story": "Historia de usuario",
      "Title": "Título",
      "State": "Estado",
      "New": "Nuevo",
      "Active": "Activo",
      "Resolved": "Resuelto",
      "Closed": "Cerrado",
      "Story Points": "Puntos de historia",
      "Value Area": "Área de valor",
      "Business": "Negocio",
      "Architectural": "Arquitectura",
      "Area": "Área",
      "Iteration Path": "Ruta de iteración",
      "Iteration": "Iteración",
      "Tags": "Etiquetas",
      "Parent": "Primario",
      "work item": "elemento de trabajo",
      "work items": "elementos de trabajo",
      "a work item": "un elemento de trabajo"
    }
  }
}
